import { DEFAULT_CSS_CLASS } from '@constants';
import { getBlockClassNames } from '@components/class-dropdown';
import BackgroundTypesSave from '@components/background-types/save';
import classnames from 'classnames';
import { flexClasses } from '@helpers/utils.js';

const {
  blockEditor: { InnerBlocks },
} = wp;

const Save = ({ attributes }) => {
  const {
    blockId,
    blockClassNames,
    backgroundType,
    backgroundGradientOptions,
    backgroundColorOptions,
    backgroundImageOptions,
    backgroundImageAndColorOptions,
    imageAsBackgroundOptions,
    imageGradientBackgroundOptions,
    backgroundVideoOptions,
    flexSettings,
    printBackgroundStyles,
  } = attributes;

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.DIV;
  const defaultBlockDynamicCssClass = `${defaultBlockCssClass}-${blockId}`;
  const classNames = getBlockClassNames(blockClassNames);

  const flexSettingsClass = flexClasses(flexSettings);

  const blockAttributes = {
    className: classnames({
      [`${defaultBlockCssClass}`]: true,
      [`${defaultBlockDynamicCssClass}`]: defaultBlockDynamicCssClass,
      [`${classNames}`]: classNames,
      [`${flexSettingsClass}`]: flexSettingsClass,
    }),
  };

  return (
    <div {...blockAttributes}>
      <BackgroundTypesSave
        {...{
          blockId,
          defaultBlockCssClass,
          backgroundType,
          backgroundGradientOptions,
          backgroundColorOptions,
          backgroundImageOptions,
          backgroundImageAndColorOptions,
          imageAsBackgroundOptions,
          imageGradientBackgroundOptions,
          backgroundVideoOptions,
          printBackgroundStyles,
        }}
      />
      <InnerBlocks.Content />
    </div>
  );
};

export default Save;
